import { Box, Icon, SelectOption, Text, useToggle } from '@factorialco/deprecated-design-system'

import Popover from 'modules/core/components/Popover'
import Select from 'modules/core/components/Select'
import i18n from 'modules/core/lib/i18n'

interface Props {
  options: SelectOption[]
  filter: string
  onChangeFilter: (type: string) => void
}

const CodesFilter = ({ options, filter, onChangeFilter }: Props) => {
  const [open, toggle] = useToggle(false)

  return (
    <Popover open={open} toggle={toggle} attachment="top center" size="auto">
      <Box
        onClick={toggle(true)}
        flexDirection="row"
        width="s120"
        justifyContent="spaceBetween"
        background="grey000White"
        border={{
          all: {
            width: 's2',
            style: 'solid',
            color: 'grey400',
          },
        }}
        borderRadius={{
          all: 'abs008',
        }}
        padding="s8"
      >
        <Text size="300">{i18n.t('codes.filters.filter')}</Text>
        <Icon.Small icon={open ? 'caret-up' : 'caret-down'} />
      </Box>

      <Box padding="s12">
        <Box textAlign="left">
          <Text.Normal>{i18n.t('codes.filters.field')}</Text.Normal>
        </Box>
        <Box>
          <Select
            options={options}
            none={i18n.t('filters.filter.none')}
            value={filter}
            onChange={onChangeFilter}
          />
        </Box>
      </Box>
    </Popover>
  )
}

export default CodesFilter
